// Selectors for visibility slice
export const getContactFormIsVisible = (state) => state.visibility.contactForm;
